/* script */
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

// Mixins
import personPickerMixin from 'ui/mixins/meetings/person-picker';
import prospectHandlingMixin from 'ui/mixins/meetings/prospect-handling';

// Components
import BaseControl from 'shared/ui/components/form-components/BaseControl.vue';
import BaseSelect from 'shared/ui/components/form-components/BaseSelect.vue';
import GenericDocExternalPicker from 'shared/ui/components/form-components/pickers/GenericDocExternalPicker.vue';
import ParticipantAvailability from 'ui/components/meetings/meeting-requests/ParticipantAvailability.vue';

const __vue_script__ = {
    name: 'AttendeePicker',

    components: { BaseSelect, GenericDocExternalPicker, ParticipantAvailability },
    extends: BaseControl,

    mixins: [personPickerMixin, prospectHandlingMixin],

    data() {
        return {
            attrs: {},
            loading: false,
            attendees_script: 'meetings/get-attendees-for-picker',
            exclusions: [],
        };
    },

    computed: {
        showAvailability() {
            return this.model.fp_type === 'meeting-request' && this.name === 'participants';
        },
        excludeProspects() {
            return this.name === 'organizer' || this.name === 'representative';
        },
    },

    methods: {
        setStatuses(statuses) {
            if (this.options.multiple) {
                for (const person of this.innerValue) {
                    const att = statuses?.find(({ fp_owner }) => fp_owner === person._id);
                    this.setPersonAttendance(person, att?.attendance);
                }
            } else {
                this.setPersonAttendance(this.innerValue, statuses?.attendance);
            }
        },

        ensureDefaultStatuses(input) {
            for (const person of [input].flat()) {
                this.setPersonAttendance(person);
            }
        }
    }
};

/* template */
var __vue_render__ = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "attendee-picker form-group",
      class: { "grouped-controls": !_vm.options.multiple },
    },
    [
      _c(
        "generic-doc-external-picker",
        _vm._b(
          {
            class: { "form-groups": !_vm.options.multiple },
            attrs: {
              "emit-key": "_id",
              "fp-type": "person",
              appscript: _vm.attendees_script,
              "appscript-extra-params": {
                excludeProspects: _vm.excludeProspects,
                withRepresentations: true,
              },
              "value-key": "ids",
              name: _vm.name,
              "event-id": _vm.event._id,
              placeholder: _vm.placeholder,
              "emit-objects": true,
              multiple: _vm.options.multiple,
              sortable: false,
              exclusions: _vm.exclusions,
              errors: _vm.errors,
            },
            on: { input: _vm.ensureDefaultStatuses },
            scopedSlots: _vm._u(
              [
                _vm.options.actions
                  ? {
                      key: "custom-actions",
                      fn: function (ref) {
                        return [
                          _vm._l(_vm.options.actions, function (action) {
                            return [
                              _vm.isActionAllowed(action)
                                ? [
                                    action.type === "anchor"
                                      ? _c(
                                          "a",
                                          {
                                            staticClass: "has-action",
                                            attrs: {
                                              href: "#",
                                              disabled: _vm.disabled,
                                            },
                                            on: {
                                              click: function ($event) {
                                                !_vm.disabled &&
                                                  _vm.performAction(action)
                                              },
                                            },
                                          },
                                          [_vm._v(_vm._s(_vm.$t(action.label)))]
                                        )
                                      : _c(
                                          "button",
                                          {
                                            staticClass: "btn btn-mini",
                                            attrs: {
                                              type: "button",
                                              disabled: _vm.disabled,
                                            },
                                            on: {
                                              click: function ($event) {
                                                !_vm.disabled &&
                                                  _vm.performAction(action)
                                              },
                                            },
                                          },
                                          [_vm._v(_vm._s(_vm.$t(action.label)))]
                                        ),
                                  ]
                                : _vm._e(),
                            ]
                          }),
                        ]
                      },
                    }
                  : null,
                {
                  key: "option",
                  fn: function (ref) {
                    var option = ref.option
                    return [
                      option.fp_type === "prospect"
                        ? _c("span", { staticClass: "subtitle ext" }, [
                            _vm._v(
                              _vm._s(
                                _vm.$t(
                                  "generic_form.external_picker.external_participant"
                                )
                              )
                            ),
                          ])
                        : _vm._e(),
                      option.fp_type === "person" &&
                      option._representation_line2
                        ? _c("span", { staticClass: "subtitle ext" }, [
                            _vm._v(_vm._s(option._representation_line2)),
                          ])
                        : _vm._e(),
                    ]
                  },
                },
                {
                  key: "document-item-subtitle",
                  fn: function (ref) {
                    var doc = ref.doc
                    return [
                      doc.fp_type === "prospect"
                        ? _c("div", { staticClass: "subtitle" }, [
                            _vm._v(
                              _vm._s(
                                _vm.$t(
                                  "generic_form.external_picker.external_participant"
                                )
                              )
                            ),
                          ])
                        : _vm._e(),
                      doc.missing_email
                        ? _c("div", { staticClass: "subtitle warning" }, [
                            _vm._v(
                              _vm._s(
                                _vm.$t(
                                  "meetings.form.hints.missing_propsect_email"
                                )
                              )
                            ),
                          ])
                        : _vm._e(),
                      doc.fp_type === "person" && doc._representation_line2
                        ? _c("div", { staticClass: "subtitle" }, [
                            _vm._v(_vm._s(doc._representation_line2)),
                          ])
                        : _vm._e(),
                    ]
                  },
                },
                {
                  key: "document",
                  fn: function (ref) {
                    var doc = ref.doc
                    return [
                      _c(
                        "div",
                        { staticClass: "doc-extras" },
                        [
                          !_vm.options.hidePaxStatus
                            ? _c("base-select", {
                                attrs: {
                                  "emit-option-value-only": true,
                                  name: _vm.name + "-acceptance",
                                  label: _vm.options.acceptance_label,
                                  options: _vm.acceptanceOptions,
                                  disabled: _vm.disabled,
                                },
                                model: {
                                  value: doc.attendance,
                                  callback: function ($$v) {
                                    _vm.$set(doc, "attendance", $$v)
                                  },
                                  expression: "doc.attendance",
                                },
                              })
                            : _vm._e(),
                          _vm.showAvailability
                            ? _c("participant-availability", {
                                attrs: {
                                  doc: doc,
                                  event: _vm.event,
                                  parentModel: _vm.model,
                                },
                              })
                            : _vm._e(),
                        ],
                        1
                      ),
                    ]
                  },
                },
                {
                  key: "doc-actions",
                  fn: function (ref) {
                    var doc = ref.doc
                    return [
                      doc.fp_type === "prospect"
                        ? _c(
                            "a",
                            {
                              staticClass: "edit has-action",
                              attrs: {
                                href: "#",
                                "aria-label": _vm.$t(
                                  "meetings.requests.participants.availability.send_email_aria_label"
                                ),
                              },
                              on: {
                                click: function ($event) {
                                  return _vm.onEditProspect(doc._id)
                                },
                              },
                            },
                            [_c("i", { staticClass: "ic-edit" })]
                          )
                        : _vm._e(),
                    ]
                  },
                },
              ],
              null,
              true
            ),
            model: {
              value: _vm.innerValue,
              callback: function ($$v) {
                _vm.innerValue = $$v
              },
              expression: "innerValue",
            },
          },
          "generic-doc-external-picker",
          _vm.attrs,
          false
        )
      ),
    ],
    1
  )
}
var __vue_staticRenderFns__ = []
__vue_render__._withStripped = true

  /* style */
  const __vue_inject_styles__ = undefined
  /* scoped */
  const __vue_scope_id__ = undefined
  /* module identifier */
  const __vue_module_identifier__ = undefined
  /* functional template */
  const __vue_is_functional_template__ = false
  /* component normalizer */
  function __vue_normalize__(
    template, style, script,
    scope, functional, moduleIdentifier, shadowMode,
    createInjector, createInjectorSSR, createInjectorShadow
  ) {
    const component = (typeof script === 'function' ? script.options : script) || {}

    // For security concerns, we use only base name in production mode.
    component.__file = "apps/backstage/src/ui/components/meetings/AttendeePicker.vue"

    if (!component.render) {
      component.render = template.render
      component.staticRenderFns = template.staticRenderFns
      component._compiled = true

      if (functional) component.functional = true
    }

    component._scopeId = scope

    if (false) {
      let hook
      if (false) {
        // In SSR.
        hook = function(context) {
          // 2.3 injection
          context =
            context || // cached call
            (this.$vnode && this.$vnode.ssrContext) || // stateful
            (this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext) // functional
          // 2.2 with runInNewContext: true
          if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
            context = __VUE_SSR_CONTEXT__
          }
          // inject component styles
          if (style) {
            style.call(this, createInjectorSSR(context))
          }
          // register component module identifier for async chunk inference
          if (context && context._registeredComponents) {
            context._registeredComponents.add(moduleIdentifier)
          }
        }
        // used by ssr in case component is cached and beforeCreate
        // never gets called
        component._ssrRegister = hook
      }
      else if (style) {
        hook = shadowMode 
          ? function(context) {
              style.call(this, createInjectorShadow(context, this.$root.$options.shadowRoot))
            }
          : function(context) {
              style.call(this, createInjector(context))
            }
      }

      if (hook !== undefined) {
        if (component.functional) {
          // register for functional component in vue file
          const originalRender = component.render
          component.render = function renderWithStyleInjection(h, context) {
            hook.call(context)
            return originalRender(h, context)
          }
        } else {
          // inject component registration as beforeCreate hook
          const existing = component.beforeCreate
          component.beforeCreate = existing ? [].concat(existing, hook) : [hook]
        }
      }
    }

    return component
  }
  /* style inject */
  
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__ = /*#__PURE__*/__vue_normalize__(
    { render: __vue_render__, staticRenderFns: __vue_staticRenderFns__ },
    __vue_inject_styles__,
    __vue_script__,
    __vue_scope_id__,
    __vue_is_functional_template__,
    __vue_module_identifier__,
    false,
    undefined,
    undefined,
    undefined
  )

  export default __vue_component__